import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import mobileEn from './locales/en/mobile.json';
import mobileIt from './locales/it/mobile.json';
import { getLocationBasedLanguage } from './utils/language';

export const DEFAULT_LANGUAGE = 'it';
export const FALLBACK_LANGUAGE = 'en';
const LOCAL_STORAGE_KEY = 'loopino.language';

export const AVAILABLE_LANGUAGES = [
  { code: 'it', label: 'Italiano' },
  { code: 'en', label: 'English' }
];

const resources = {
  en: { mobile: mobileEn },
  it: { mobile: mobileIt }
};

// Initialize i18next using a dedicated namespace for the mobile app
const initialLanguage = getLocationBasedLanguage(LOCAL_STORAGE_KEY) || DEFAULT_LANGUAGE;
export const i18nReady = i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: [DEFAULT_LANGUAGE, FALLBACK_LANGUAGE],
    supportedLngs: AVAILABLE_LANGUAGES.map(({ code }) => code),
    ns: ['mobile'],
    defaultNS: 'mobile',
    interpolation: {
      escapeValue: false // React already escapes values
    },
    returnEmptyString: false
  });

export default i18n;
